import React, { PureComponent } from 'react';

import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import Category from './styled/Category';

export default class OfferSection extends PureComponent {
  static defaultProps = {
    filter: 'All projects',
  };

  state = {
    activeCategory: 'all',
  };

  static contextType = ThemeContext;

  onClickCategory = key => e => {
    const { active, categories } = this.props;

    active(key);
    this.setState({ activeCategory: key });
    // if(appState.analytics)appState.analytics._trackEvent(
    //   'WorksPage',
    //   'click filter',
    //   key === 'all' ? 'all' : categories.filter(cat => cat.key === key)[0].name.toLowerCase()
    // );

  };

  render() {
    const { categories, filter } = this.props;
    const { activeCategory } = this.state;

    return (
      <Wrapper>
        <Category
          key="all"
          onClick={this.onClickCategory('all')}
          active={'all' === activeCategory}
          theme={this.context}
          index={1}
        >
          {filter}
        </Category>
        {categories.map((category, index) => (
          <Category
            key={category.key}
            onClick={this.onClickCategory(category.key)}
            active={category.key === activeCategory}
            theme={this.context}
            index={index + 1}
          >
            {category.name}
          </Category>
        ))}
      </Wrapper>
    );
  }
}
